import { LOCALE } from '@foxrenderfarm/internals'
import { baseTaskUrl } from './env'

export const getRegisterLink = (locale: LOCALE, search = '') => {
  const baseRegisterLink = `${baseTaskUrl()}/sso/signup`
  const linkMap = new Map([[LOCALE.KR, `${baseRegisterLink}?key=6hsP2oc4EiIX2533`]])
  let link = linkMap.get(locale) || baseRegisterLink
  if (search && search.startsWith('?')) {
    link = `${link}${link.includes('?') ? '&' : '?'}${search.substring(1)}`
  }
  return link
}
